import {
    // Constants
    STEAM_CHANGED,
    STEAM_TICKET_CHANGED,

    // Actions
    updateSteam,
    setUsedTicket,

    // Selectors
    isSteamStartup,
    getSteamInfo,
} from './data'

// Reducer is exposed so that we can hook up the state
export { default as steamReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

export const constants = {
    STEAM_CHANGED, // Creatives
    STEAM_TICKET_CHANGED, // LocalForageMiddleware
}

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    isSteamStartup, // SideMenu, LoadingBar, Creatives
    getSteamInfo, // LoginWindow, Dashboard
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    updateSteam, // LoginWindow and SteamValidation
    setUsedTicket, // LocalForage
}



// WEBPACK FOOTER //
// ./src/features/Steam/exports.js